import React from "react";

const brandName = "KeytoAbode";

const commonPageStyle = {
  margin: "2% auto",
  border: "1px solid #333",
  maxWidth: "1100px",
  background: "#fff",
  color: "#222",
};

const commonContentStyle = {
  margin: "auto",
  font: "normal 13px arial",
  padding: "30px",
};

const paragraphStyle = {
  paddingTop: "10px",
  textAlign: "justify",
  lineHeight: "24px",
};

export default function DisclaimerPrivacyPolicy() {
  return (
    <div className="container" style={commonPageStyle}>
      <div style={commonContentStyle}>
        <h2 style={{ textAlign: "center", fontSize: "20px" }}>Disclaimer</h2>
        <p style={paragraphStyle}>
          <b style={{ display: "block", fontSize: "15px" }}>Disclaimer</b>
          The Information Provided On This Website Is Intended Exclusively For Informational Purposes
          And Should Not Be Construed As An Offer Of Services. This Site Is Managed By A RERA
          Authorized Real Estate Agent Namely - {brandName}. The Pricing Information Presented
          On This Website Is Subject To Alteration Without Advance Notification, And The Assurance Of
          Property Availability Cannot Be Guaranteed. The Images Showcased On This Website Are For
          Representational Purposes Only And May Not Accurately Reflect The Actual Properties.
        </p>
        <p style={paragraphStyle}>
          We May Share Your Data With Real Estate Regulatory Authority (RERA) Registered Developers
          For Further Processing As Necessary. Additionally, We May Send Updates And Information To
          The Mobile Number Or Email Address Registered With Us. All Rights Reserved. The Content,
          Design, And Information On This Website Are Protected By Copyright And Other Intellectual
          Property Rights. Any Unauthorized Use Or Reproduction Of The Content May Violate Applicable
          Laws.
        </p>
        <p style={paragraphStyle}>
          <b style={{ display: "block", fontSize: "15px" }}>Governing Law</b>
          Shashi Kumar Gupta is the RERA-registered agent for KeytoAbode under Karnataka Real
          Estate Regulatory Authority (RERA). Agent RERA: PRM/KA/RERA/1251/308/AG/250811/005905.
        </p>
        <p style={paragraphStyle}>
          For accurate and up-to-date information regarding services, pricing, availability, and any
          other details, it is recommended to contact Shashi Kumar Gupta directly through the
          provided contact information on this website. Thank you for visiting our website!
        </p>
        <p style={paragraphStyle}>
          <strong>
            This website is an independent marketing platform and not the official website of the
            developer. We act as marketing partners and provide information about the project for
            customer assistance.
          </strong>
        </p>
      </div>
    </div>
  );
}

export function PrivacyPolicy() {
  return (
    <div className="container" style={commonPageStyle}>
      <div style={commonContentStyle}>
        <h2 style={{ textAlign: "center", fontSize: "20px" }}>
          Privacy Policy &amp; Terms of Use
        </h2>
        <p style={paragraphStyle}>
          {brandName}, Authorised Marketing Partner for project enquiries, is a Real Estate
          Regulatory Authority (RERA) registered agent operating under Shashi Kumar Gupta and
          bearing RERA No: PRM/KA/RERA/1251/308/AG/250811/005905. We prioritize your privacy. This
          Privacy Policy outlines the personal information we collect through our website,
          including sub-domains and microsites, the purposes of collection, whom we may share it
          with, and the security measures in place. It also informs you about your rights, choices,
          and how to contact us regarding privacy concerns. We recommend reading this Privacy Policy
          before using our services or providing personal information.
        </p>
        <p style={paragraphStyle}>
          <b style={{ display: "block", fontSize: "15px" }}>Interpretations and Definitions</b>
          "Data" shall mean personal information, including sensitive personal information and
          special category personal data, as defined under applicable Data Protection Laws, about you
          which we collect, receive, or otherwise process in connection with your use of our website
          or platform. "Data Protection Laws" shall mean any applicable law for the time being in
          force relating to the processing of Data. "Service Providers" includes entities which
          provide services to us and to whom we may disclose your Data for a specific purpose pursuant
          to a written contract. "We", "Us", or "Our" shall mean {brandName} and authorized
          associates involved in marketing promoted projects. "User" or "You" shall mean the natural
          person who accesses our website, pages, or platform.
        </p>
        <p style={paragraphStyle}>
          <b style={{ display: "block", fontSize: "15px" }}>Website Content Overview</b>
          The contents of this landing page, containing details of promoted projects, property photos,
          costs, amenities, plans, and availability, are provided for informational and illustrative
          purposes only. This information is subject to change at any time. Users are advised that
          actual properties, specifications, availability, and pricing may differ from what is shown
          on the website, and no claims shall be entertained based solely on such representations.
        </p>
        <p style={paragraphStyle}>
          <b style={{ display: "block", fontSize: "15px" }}>Use of Developer Information</b>
          All images, cost descriptions, logos, and other project materials featured on this landing
          page are presented in accordance with the respective project developer or its licensors.
          We work as an authorized marketing partner for the project and use these materials for
          advertising, marketing, and lead generation for promoted projects.
        </p>
        <p style={paragraphStyle}>
          <b style={{ display: "block", fontSize: "15px" }}>Types of Data Collected</b>
          While visiting this website, we may ask you to provide certain personally identifiable
          information that can be used to contact or identify you. Personally identifiable information
          may include, but is not limited to, email address, first name and last name, phone number,
          address, state, province, ZIP or postal code, and city.
        </p>
        <p style={paragraphStyle}>
          <b style={{ display: "block", fontSize: "15px" }}>Use of Personal Data</b>
          We may use Personal Data to provide and maintain our service, monitor usage of our service,
          contact you by email, telephone call, SMS, WhatsApp, or other equivalent forms of
          electronic communication, provide information related to property sale, purchase, offers,
          and real estate services, and manage your requests or enquiries submitted to us.
        </p>
        <p style={paragraphStyle}>
          <b style={{ display: "block", fontSize: "15px" }}>Sharing of Personal Data</b>
          We may share your personal information with associated entities, authorized associates, service
          providers, and Real Estate Regulatory Authority (RERA) registered developers for further
          processing as necessary. We may also disclose your personal information for any other
          purpose with your consent.
        </p>
        <p style={paragraphStyle}>
          <b style={{ display: "block", fontSize: "15px" }}>Retention of Your Personal Data</b>
          We shall retain your Personal Data only for as long as necessary for the purposes set out
          in this Privacy Policy. We will retain and use your Personal Data to the extent necessary
          to comply with legal obligations, resolve disputes, and enforce our agreements and policies.
        </p>
        <p style={paragraphStyle}>
          <b style={{ display: "block", fontSize: "15px" }}>User Consent</b>
          By using this website or landing page and by providing information to us through this
          website, you consent to the collection and use of the information disclosed by you in
          accordance with this Privacy Policy.
        </p>
        <p style={paragraphStyle}>
          <b style={{ display: "block", fontSize: "15px" }}>Disclosure of Your Personal Data</b>
          Under certain circumstances, we may be required to disclose your Personal Data if required
          by law or in response to valid requests by public authorities, including a court or
          government agency. We may also disclose your Personal Data in good faith where such action
          is necessary to comply with a legal obligation, prevent or investigate possible wrongdoing,
          protect the personal safety of users or the public, or protect against legal liability.
        </p>
        <p style={paragraphStyle}>
          <b style={{ display: "block", fontSize: "15px" }}>Security of Your Personal Data</b>
          The security of your Personal Data is important to us, but no method of transmission over
          the Internet or method of electronic storage is completely secure. While we strive to use
          commercially acceptable means to protect your Personal Data, we cannot guarantee its
          absolute security.
        </p>
        <p style={paragraphStyle}>
          <b style={{ display: "block", fontSize: "15px" }}>Children's Privacy</b>
          Our service does not address anyone under the age of 18. We do not knowingly collect
          personally identifiable information from anyone under the age of 18. If you are a parent or
          guardian and you are aware that your child has provided us with Personal Data, please
          contact us. If we become aware that we have collected Personal Data from anyone under the
          age of 18 without verification of parental consent, we take steps to remove that
          information from our records.
        </p>
        <p style={paragraphStyle}>
          <b style={{ display: "block", fontSize: "15px" }}>Changes to This Privacy Policy</b>
          We may update our Privacy Policy from time to time. We will notify you of any changes by
          posting the new Privacy Policy on this page. You are advised to review this Privacy Policy
          periodically for any changes. Changes to this Privacy Policy are effective when they are
          posted on this page.
        </p>
        <p style={paragraphStyle}>
          <b style={{ display: "block", fontSize: "15px" }}>Contact Us</b>
          To request to review, update, or delete your personal information, or to otherwise reach
          us regarding privacy concerns, please contact us directly through the contact information
          provided on this website.
        </p>
      </div>
    </div>
  );
}

export function TermsAndConditions() {
  return (
    <div className="container" style={commonPageStyle}>
      <div style={commonContentStyle}>
        <h2 style={{ textAlign: "center", fontSize: "20px" }}>Terms &amp; Conditions</h2>
        <p style={paragraphStyle}>
          This website is operated for project enquiries by {brandName}, Authorised Marketing
          Partner, under Shashi Kumar Gupta. Agent RERA: PRM/KA/RERA/1251/308/AG/250811/005905. By
          visiting this website and accessing the information, resources, services, products, and
          tools we provide, you understand and agree to accept and adhere to the following terms and
          conditions, along with the terms stated in our Privacy Policy.
        </p>
        <p style={paragraphStyle}>
          We reserve the right to change this User Agreement from time to time without notice. You
          acknowledge and agree that it is your responsibility to review this User Agreement
          periodically to familiarize yourself with any modifications. Your continued use of this site
          after such modifications will constitute acknowledgment and agreement of the modified terms
          and conditions.
        </p>
        <p style={paragraphStyle}>
          <b style={{ display: "block", fontSize: "15px" }}>Responsible Use and Conduct</b>
          By visiting our website and accessing the information, resources, services, products, and
          tools we provide, either directly or indirectly, you agree to use these resources only for
          the purposes intended and as permitted by this User Agreement, applicable laws, regulations,
          and generally accepted online practices or guidelines.
        </p>
        <p style={paragraphStyle}>
          You may be required to provide certain information about yourself, such as identification
          or contact details, as part of the registration process or your ability to use our resources.
          You agree that any information you provide will always be accurate, correct, and up to date.
          You are responsible for maintaining the confidentiality of any login information associated
          with any account you use to access our resources, and you are responsible for all activities
          that occur under your account.
        </p>
        <p style={paragraphStyle}>
          Accessing or attempting to access any of our resources by any means other than through the
          means we provide is strictly prohibited. You specifically agree not to access or attempt to
          access any resources through automated, unethical, or unconventional means. Engaging in any
          activity that disrupts or interferes with our resources, including servers or networks to
          which our resources are connected, is strictly prohibited. Attempting to copy, duplicate,
          reproduce, sell, trade, or resell our resources is strictly prohibited.
        </p>
        <p style={paragraphStyle}>
          You are solely responsible for any consequences, losses, or damages that we may directly or
          indirectly incur or suffer due to unauthorized activities conducted by you, and such conduct
          may incur criminal or civil liability. We may provide open communication tools on our
          website, such as comments, chat, forums, message boards, ratings, reviews, or social media
          services. You agree to use these tools responsibly and ethically.
        </p>
        <p style={paragraphStyle}>
          By posting information or otherwise using any open communication tools, you agree that you
          will not upload, post, share, or distribute any content that is illegal, threatening,
          defamatory, abusive, harassing, degrading, intimidating, fraudulent, deceptive, invasive,
          racist, inappropriate, explicit, infringes any intellectual property right, contains
          unauthorized or unsolicited advertising, or impersonates any person or entity. We reserve
          the right, at our sole discretion, to remove any content that does not comply with this
          User Agreement or is otherwise offensive, harmful, objectionable, inaccurate, or violates
          third-party copyrights or trademarks.
        </p>
        <p style={paragraphStyle}>
          We do not assume liability for any content posted by you or any other third-party users of
          our website. Any content posted by you using open communication tools on this website,
          provided that it does not violate third-party copyrights or trademarks, grants us a
          perpetual, irrevocable, worldwide, royalty-free license to reproduce, modify, adapt,
          translate, publish, publicly display, and distribute such content as required for website
          operations and marketing communication. Information provided as part of enquiry or
          registration processes is covered by our Privacy Policy.
        </p>
        <p style={paragraphStyle}>
          <b style={{ display: "block", fontSize: "15px" }}>Privacy</b>
          Your privacy is important to us. Our Privacy Policy explains how we collect, manage,
          process, secure, and store your personal information. Our Privacy Policy is included under
          the scope of this User Agreement.
        </p>
        <p style={paragraphStyle}>
          <b style={{ display: "block", fontSize: "15px" }}>Limitation of Warranties</b>
          By using our website, you understand and agree that all resources we provide are provided
          "as is" and "as available". We do not represent or warrant that use of our resources will
          meet your needs or requirements, will be uninterrupted, timely, secure, or error-free, that
          information obtained through our resources will be accurate or reliable, or that any defects
          in the operation or functionality of our resources will be repaired or corrected.
        </p>
        <p style={paragraphStyle}>
          Any content downloaded or otherwise obtained through the use of our resources is done at
          your own discretion and risk. You are solely responsible for any damage to your computer or
          devices, or any loss of data, that may result from downloading such content. No information
          or advice, whether expressed, implied, oral, or written, obtained through our resources
          shall create any warranty, guarantee, or conditions of any kind except those expressly
          outlined in this User Agreement.
        </p>
        <p style={paragraphStyle}>
          <b style={{ display: "block", fontSize: "15px" }}>Limitation of Liability</b>
          You expressly understand and agree that any claim against us shall be limited to the amount
          you paid, if any, for use of products or services. We will not be liable for any direct,
          indirect, incidental, consequential, or exemplary loss or damages incurred as a result of
          using our resources, changes, data loss or corruption, cancellation, loss of access, or
          downtime, to the fullest extent permitted by applicable law.
        </p>
        <p style={paragraphStyle}>
          <b style={{ display: "block", fontSize: "15px" }}>Termination of Use</b>
          You agree that we may, at our sole discretion, suspend or terminate your access to all or
          part of our website and resources with or without notice and for any reason, including
          breach of this User Agreement. Any suspected illegal, fraudulent, or abusive activity may be
          grounds for termination and may be referred to appropriate law enforcement authorities. Upon
          suspension or termination, your right to use the resources we provide will immediately
          cease.
        </p>
        <p style={paragraphStyle}>
          <b style={{ display: "block", fontSize: "15px" }}>Project Information</b>
          Prices, offers, specifications, dimensions, amenities, approvals, possession timelines, and
          availability for promoted projects are subject to change without prior notice. Images, plans,
          and visuals shown on this website are for representational purposes only and may differ from
          actual properties. Users are advised to verify all details including RERA registration,
          developer approvals, pricing, availability, possession timelines, and legal documentation
          directly before making any purchase decision.
        </p>
        <p style={paragraphStyle}>
          <b style={{ display: "block", fontSize: "15px" }}>Governing Law</b>
          Any action to enforce this User Agreement shall be brought before the appropriate courts
          located in India, Karnataka. You hereby agree to personal jurisdiction by such courts and
          waive any jurisdictional, venue, or inconvenient forum objections to such courts.
        </p>
      </div>
    </div>
  );
}
